// -----> Settings
$(document).ready(initCookieLayer);

const GOOGLE_ANALYTICS_ID = "abc"; // Google-Analytics ID
const COOKIE_EXPIRATION_DAYS = 7; // Tage, nach denen der Cookie abläuft

// -----> Prüfen. ob Cookies im verwendeten Browser erlaubt sind
var cookieEnabled = navigator.cookieEnabled;

function initCookieLayer() {
  // onload Funktionen
  if (cookieEnabled) {
    getLayerState();
    cookieMenu();
    showMap();
  } else {
    disableCookieSettings();
  }

  // --------------------> Events <--------------------

  // -----> Accept Cookies
  $(".cookie-layer__button-yes").click(function () {
    jQuery(".cookie-layer").hide("fast");
    jQuery(".cookie-layer__overlay").hide("fast");
    setCookie("cookieOptin", "in", COOKIE_EXPIRATION_DAYS);
    jQuery(".cookie-layer__changer").show("fast");
    cookieMenu();
    loadGAonConsent();
    showMap();
  });

  // -----> Reject Cookies
  $(".cookie-layer__button-no").click(function () {
    jQuery(".cookie-layer").hide("slow");
    jQuery(".cookie-layer__overlay").hide("slow");
    setCookie("cookieOptin", "out", COOKIE_EXPIRATION_DAYS);
    jQuery(".cookie-layer__changer").show("fast");
    cookieMenu();
    showMap();
  });

  // -----> Cookie Icon Handler
  $(".cookie-layer__changer--icon").click(function () {
    $(".cookie-layer__changer--icon").hide();
    setCookieStatus();
    $(".cookie-layer__changer--wrapper").show();
  });
  // -----> Cookie Change menu btn handler
  $("#cookie-menu-saver").click(function () {
    $(".cookie-layer__changer--wrapper").hide();
    $(".cookie-layer__changer--icon").show();
    showMap();
  });
  // -----> Cookie Change Menu close handler
  $("#cookie-setting-closer").click(function () {
    $(".cookie-layer__changer--wrapper").hide();
    $(".cookie-layer__changer--icon").show();
    showMap();
  });

  // -----> Cookie Change Menu Checklist Listener
  $(".cookie-setting").click(function () {
    var ID = $(this);
    ID = ID.attr("id");
    if (ID == "cookie-setting-yes") {
      setCookie("cookieOptin", "in", COOKIE_EXPIRATION_DAYS);
      $("#cookie-setting-no").prop("checked", false);
      $(this).prop("checked", true);
    } else {
      setCookie("cookieOptin", "out", COOKIE_EXPIRATION_DAYS);
      $("#cookie-setting-yes").prop("checked", false);
      $(this).prop("checked", true);
    }
  });

  // -----> Cookie OptOut öffnen
$("#cookie-optout").click(function () {
  $(".cookie-layer").show();
});
}



/**
 * -----> setCookie
 *
 * setzt einen Cookie.
 *
 * @param {string} cname Cookie name
 * @param {string} cvalue Cookie value
 * @param {int} exdays Days till expiration
 */
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie =
    cname + "=" + cvalue + "; " + expires + ";path=/; SameSite=Lax";
}

/**
 * -----> getCookie
 *
 * Auslesen von bereits gesetzten Cookies.
 *
 * @param {string} cname Cookie-name
 */
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

/**
 * -----> loadGoogleAnalytics
 *
 * Läd das GoogleAnalytics Skript in den head.
 */
function loadGAonConsent() {
  window.ga =
    window.ga ||
    function () {
      (ga.q = ga.q || []).push(arguments);
    };
  ga.l = +new Date();
  ga("create", GOOGLE_ANALYTICS_ID, "auto");
  ga("set", "anonymizeIp", true);
  ga("send", "pageview");
  var gascript = document.createElement("script");
  gascript.async = true;
  gascript.src = "https://www.google-analytics.com/analytics.js";
  document
    .getElementsByTagName("head")[0]
    .appendChild(gascript, document.getElementsByTagName("head")[0]);
}

/**
 * -----> getLayerState
 *
 * Prüft, ob ein cookie gesetzt ist und zeigt/versteckt den Cookie-Layer
 */
function getLayerState() {
  if (getCookie("cookieOptin") == "in" || getCookie("cookieOptin") == "out") {
    $(".cookie-layer").hide();
    $(".cookie-layer__overlay").hide();
    $(".cookie-layer__changer").show();
  } else {
    $(".cookie-layer").show();
    $(".cookie-layer__overlay").show();
    $(".cookie-layer__changer").hide();
  }
}

function disableCookieSettings() {
  $("#change-cookies").find("input").attr("disabled", true);
}

// Checkliste im Cookie Eisntellungsmenü, es kann nur eine Checkbox gewählt werden
function setCookieStatus() {
  if (getCookie("cookieOptin") == "in") {
    $("#cookie-setting-yes").prop("checked", true);
    $("#cookie-setting-no").prop("checked", false);
  } else {
    $("#cookie-setting-no").prop("checked", true);
    $("#cookie-setting-yes").prop("checked", false);
  }
}
/**
 * -----> showMap
 *
 * anzeigen der Google Maps Karte, fügt src ins iframe ein
 */
function showMap() {
  if (getCookie("cookieOptin") == "in") {
    $(".text-map__iframe").attr(
      "src",
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2626.727330234468!2d9.225097916382165!3d48.825263779284334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4799c567b2c6015b%3A0x3bf377b480d52992!2sZuckerbergstra%C3%9Fe%2082%2C%2070378%20Stuttgart!5e0!3m2!1sde!2sde!4v1676045276890!5m2!1sde!2sde"
    );
    $(".text-map__image").hide();
  } else {
    $(".text-map__iframe").removeAttr("src");
    $(".text-map__image").show();
  }
}

// Cookie Change Menu show() if cookie is set
function cookieMenu() {
  if (getCookie("cookieOptin") !== "") {
    $(".cookie-layer__changer").show(); 
  }
}
